// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".refresh[data-v-d5e3627c] {\n  padding-left: 10px;\n}\n.refresh[data-v-d5e3627c]:hover {\n  cursor: pointer;\n  --tw-text-opacity: 1;\n  color: rgba(13, 148, 103, var(--tw-text-opacity));\n}", ""]);
// Exports
module.exports = exports;
